import { useEffect, useState } from "react";
import { FaFilePdf } from "react-icons/fa6";
import { ConvertPriceToString } from "../../../Helpers/CustomConverter";
import useDownloadFinanceDocuments from "../../../Hooks/useDownloadFinanceDocuments";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { formatDocumentNumber } from "../../../Helpers/DocumNumHelper";
import { useAuth } from "../../../Providers/AuthProvider";
import { useInvoices } from "../../../Providers/InvoicesProvider";
import InvoiceItems from "../Invoices/InvoiceItems";
import { Licenses } from "../../../Data/Licenses.ts";
import { useParams } from "../../../Providers/ParamsProvider";

const UnPaidInvoice = ({ invoice, setShowNoEInvoiceModal }) => {
    const [isChecked, setIsChecked] = useState(false);
    const dateToCompare = new Date(invoice.dateToPay);
    const { downloadFinanceDocument, isLoading } = useDownloadFinanceDocuments();
    const { authState } = useAuth()
    const { handleGetUnPaidInvoiceItems } = useInvoices()
    const [showItems, setShowItems] = useState(false)
    const [invoiceItems, setInvoiceItems] = useState([])
    const [isLoadingItems, setIsLoadingItems] = useState(false)
    const { license } = useParams();
    const today = new Date();
    var textColor = '#000000'

    // Normalizacja dat (usuwanie czasu)
    const dateToCompareStart = new Date(dateToCompare.getFullYear(), dateToCompare.getMonth(), dateToCompare.getDate());
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Obliczanie różnicy dni
    const differenceInTime = dateToCompareStart - todayStart; // Wynik w milisekundach
    const differenceInDays = -Math.round(differenceInTime / (1000 * 60 * 60 * 24)); // Przeliczenie na dni

    if (differenceInDays > 0 && invoice.remainToPaid >= 0) {
        textColor = '#d81b24'
    } else {
        textColor = '#000000'
    }

    useEffect(() => {
        if (showItems) {
            handleGetInvoiceItems()
        }
    }, [showItems])

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    function reverseDate(date) {
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
    }

    const handleDownloadPdf = () => {
        if ((authState.user && authState.user.customerInfo && authState.user.customerInfo[0].isEInvoiceConsent) || (authState.user && authState.user.isOperator)) {
            downloadFinanceDocument(invoice.docNumber, invoice.docCreated, invoice.wh)
            return
        }
        else {
            setShowNoEInvoiceModal(true)
        }
    }

    const handleGetInvoiceItems = async () => {
        setIsLoadingItems(true)
        const invoiceItems = await handleGetUnPaidInvoiceItems(invoice)
        setInvoiceItems(invoiceItems)
        setIsLoadingItems(false)
    }

    return (
        <>
            <tr className="hoverable-row element-pointer" onClick={() => setShowItems(prev => !prev)}>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'left', fontSize: '14px' }}>
                    <span style={{ color: textColor }}>
                        {differenceInDays > 0 && invoice.remainToPaid >= 0 ? <>{differenceInDays + ' dni'}<br />
                            <span style={{ fontWeight: "bold" }}>{reverseDate(invoice.dateToPay.substring(0, invoice.docCreated.indexOf("T")))}</span></> :
                            <span style={{ fontWeight: "bold" }}>{reverseDate(invoice.dateToPay.substring(0, invoice.docCreated.indexOf("T")))}</span>}
                    </span>
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }}>{license == Licenses.TgInstalacje ? invoice.seller.toLocaleLowerCase().replace('tg instalacje sp. z o.o. ', '').toLocaleUpperCase() : invoice.seller}</td>
                <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{invoice.docName}</td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }}>{formatDocumentNumber(invoice.docNumber, invoice.docCreated, invoice.wh)}</td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }}>
                    {reverseDate(invoice.docCreated.substring(0, invoice.docCreated.indexOf("T")))}
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: "right", fontSize: '14px' }}>
                    <span style={{ fontWeight: "bold" }}>{ConvertPriceToString(invoice.value, null)}</span>
                    <br />
                    {ConvertPriceToString(invoice.paidValue, null)}
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right', fontSize: '14px' }}>
                    {/* <span style={{ fontWeight: "bold" }}>{ConvertPriceToString((invoice.value - invoice.paidValue), null)}</span> */}
                    {ConvertPriceToString((invoice.remainToPaid), null)}

                </td>
                <td style={{ fontSize: '14px', verticalAlign: 'middle' }}>
                    {invoice.comments}
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: "center" }}>
                    {isLoading ? <LoadingSpinner width={2} height={2} bubble={false} /> : <FaFilePdf style={{ cursor: "pointer" }} color="black" size={20} onClick={() => handleDownloadPdf()} />}
                </td>
            </tr >
            {showItems && (
                <tr>
                    <td colSpan="9" style={{ padding: 10 }}>
                        <InvoiceItems items={invoiceItems} isLoading={isLoadingItems} />
                    </td>
                </tr>
            )
            }
        </>
    );
};

export default UnPaidInvoice;
